import { render, staticRenderFns } from "./EvaluacionDisciplinaAdministrativaDialogComponent.vue?vue&type=template&id=2c38c1c6"
import script from "./EvaluacionDisciplinaAdministrativaDialogComponent.vue?vue&type=script&lang=js"
export * from "./EvaluacionDisciplinaAdministrativaDialogComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports